<template>
  <div>
    <span @click='openWelcomePopup()' class='cursor-pointer'></span>
    <welcome-popup></welcome-popup>
    <render-popup :roleId="roleId" :displayRep="displayRep" :playNextTour='playNextTour' :previousTour='previousTour'
      :currentTour='currentTour' :showSElink='showSElink' :tourObjectLength="tourObject.length"
      :tourIndex="tourIndex"></render-popup>
    <!-- <account-settings-popup :previousTour="previousTour" :tourlength="tourObject.length"></account-settings-popup> -->
    <success-popup></success-popup>
  </div>
</template>
<script>
import $ from 'jquery';
import WelcomePopup from './WelcomePopup.vue';
import RenderPopup from './RenderPopup.vue';
import { getRamsTour } from '../../apis/dashboard';
import SuccessPopup from './SuccessPopup.vue';
import EventBus from '../../utils/event-bus';

export default {
  components: {
    WelcomePopup,
    RenderPopup,
    SuccessPopup,
  },
  props: ['displayRep', 'showSElink'],
  data() {
    return {
      roleId: 0,
      tourIndex: 0,
      displayTour: false,
      currentTour: {},
      tourObject: [
        {
          key: 0,
          type: 'Dashboard',
          title: 'Central hub to access top resources',
          content:
            '<ul class="item-container"><li><span>Jump to a specific section in the Dashboard to know more details about our features and services.<span/></li>'
            + '<li><span>View or add records & compliance details in the Compliance Tracker for your products.<span></li><li><span>Immediately access top resources, like popular tools and documents in the Resource section.<span></li></ul>',
          url: '/layout/dashboard',
          image: '/static/images/icons/tour_dashboard_icon.svg',
          clickValue: 3,
          topSpace: 118,
        },
        {
          key: 1,
          type: 'Marketplace',
          title: 'Purchase premium resources and subscriptions',
          content: '<ul><li><span>Purchase premium features and services from the Marketplace.<span></li>'
            + '<li><span>Flexible subscription options to maximize resources for your products.<span></li><li><span>Purchase premium tools and documents.<span></li></ul>',
          url: '/layout/market-place',
          clickValue: 63,
          topSpace: 192,
          image: '/static/images/icons/tour_marketplace_icon.svg',
        },
        {
          key: 2,
          type: 'Notifications',
          title: 'View messages about your recent activities',
          content: '<ul><li><span>Receive confirmation of purchases, document and compliance resources and more.<span/></li><li><span>Receive confirmation when a certification is approved for products.<span/></li><li><span>Receive messages about new content.<span/></li></ul>',
          url: '/layout/alert',
          clickValue: 98,
          topSpace: 227,
          image: '/static/images/icons/tour_notifications_icon.svg',
        },
        {
          key: 3,
          type: 'Compliance Tracker',
          title: 'Automated tool to control product self-certifications',
          content: '<ul><li><span>Save time with automated compliance tracking.<span/></li><li><span>Grow your business with advanced compliance tracking updates of your product certifications.<span/></li><li><span>Get “big picture” data insights in one simple graphic. Instantly share resources and information with teammates.<span/></li></ul>',
          url: '/layout/registration',
          clickValue: 150,
          topSpace: 293,
          image: '/static/images/icons/tour_compliance_tracker_icon.svg',
        },
        {
          key: 4,
          type: 'Resources',
          title: 'Explore your product compliance and certification resources',
          content: '<ul><li><span>Want to exploring certification resources? Quickly locate top resources and services.<span/></li><li><span>Immediate access to service provider details.<spa/></li><li><span>Estimate costs and historical data for your product’s self-certification standards.<span/></li></ul>',
          url: '/layout/tools/classification',
          clickValue: 235,
          topSpace: 348,
          image: '/static/images/icons/tour_resources_icon.svg',
        },
        // {
        //   key: 3,
        //   type: 'Smart Docs',
        //   title: 'Centralize Your RA/QA Documentation',
        //   content: '<ul><li>Store your documentation in a one spot to make them easier to locate</li><li>Upload documents to share with team members</li><li>INMETRO security features keep your data safe</li></ul>',
        //   url: '/layout/smart-docs',
        //   clickValue: 151,
        //   topSpace: 53,
        //   image: '/static/images/icons/smart_docs.svg',
        // },
        // {
        //   key: 4,
        //   type: 'Resources',
        //   title: 'Explore global RA/QA resources',
        //   content: '<ul><li>Exploring a specific market? Quickly locate INMETRO resources and services that help</li>'
        //     + '<li>Immediate access to regulations and guidances</li><li>Estimate costs and historical data for expanding your business</li></ul>',
        //   url: '/layout/resourcesdashboard',
        //   clickValue: 195,
        //   image: '/static/images/icons/resources_icon.svg',
        // },
        // {
        //   key: 5,
        //   type: 'Regulations & Guidances',
        //   title: 'Global resources at your fingertips',
        //   content: '<ul><li>Immediately locate requirements for more than 40 markets</li><li>Save time finding the information your business needs</li>'
        //     + '<li>Regularly updated by Emergo by UL’s team of industry experts</li></ul>',
        //   url: '/layout/regsandguidance',
        //   clickValue: 232,
        // },
        // {
        //   key: 6,
        //   type: 'Representation Resources',
        //   title: 'Exclusive to in-country representation clients',
        //   content: '<ul><li>Instant access to templates, checklists, cheat sheets, and more</li><li>Download individual documents or select all items for that market</li>'
        //     + '<li>Easily customize  templates to your needs</li></ul>',
        //   url: '/layout/representationresources',
        //   clickValue: 266,
        // },
        // {
        //   key: 7,
        //   type: 'Market Insights',
        //   title: 'Resources tailored to medical device, IVD professionals',
        //   content: '<ul><li>Listen to RA/QA podcasts exclusively available in INMETRO</li>'
        //     + '<li>Find the latest webinars from Emergo’s world class consulting experts</li><li>Download whitepapers for free</li></ul>',
        //   url: '/layout/market-insights',
        //   clickValue: 301,
        // },
        // {
        //   key: 8,
        //   type: 'Tools',
        //   title: 'Free with your INMETRO subscription',
        //   content: '<ul><li>Estimate approval time required for your next FDA 510(k)</li>'
        //   + '<li>FDA Product Classification Lookup saves time searching for information</li><li>Government Fee Finder identifies government filing costs when expanding into new markets</li></ul>',
        //   url: '/layout/tools',
        //   clickValue: 334,
        // },
        // {
        //   key: 9,
        //   type: 'Smart Exchange',
        //   title: 'Easily manage your RA/QA projects',
        //   content: '<ul><li>Quickly and easily track progress of your regulatory affairs projects</li>'
        //     + '<li>Immediately identify which elements of your project are complete and which are still outstanding</li><li>Includes definitions for what needs to be included in each element of your project</li></ul>',
        //   url: '/layout/smart-exchange',
        //   clickValue: 239,
        //   image: '/static/images/icons/smartexchange_icon.svg',
        // },
        // {
        //   key: 10,
        //   type: 'Product Classification',
        //   title: 'Unlock new markets, download key insights',
        //   content: '<ul><li>Quickly determine or verify device classification</li>'
        //   + '<li>Download valuable reports to guide device strategy</li><li>Flexible service options to access expert support specific to your device and situation</li></ul>',
        //   url: '/layout/prodclassification',
        //   clickValue: 285,
        //   image: '/static/images/icons/prod_classification_icon.svg',
        // },
        // {
        //   key: 11,
        //   type: 'Regulatory Reports',
        //   title: 'Global vision to scale your business',
        //   content: '<ul><li>Go-to resource for understanding how regulatory bodies operate in each country</li>'
        //   + '<li>Locate requirements and resources for in-country representation, importers, and distributors</li><li>Avoid costly business interruptions and stay on market post-approval</li></ul>',
        //   url: '/layout/regulatory-pathway',
        //   clickValue: 325,
        //   image: '/static/images/icons/reg_pathway_icon.svg',
        // },
        // {
        //   key: 12,
        //   type: 'Smart Builder',
        //   title: 'Easy and efficient regulatory documents',
        //   content: '<ul><li>Reduce time-consuming errors that derail regulatory approval</li>'
        //   + '<li>Intuitive tools walk you through approval for multiple markets</li><li>Improve your team’s collaboration</li><li>Generate professional documents aligned with governing body standards</li></ul>',
        //   url: '/layout/submission-builder',
        //   clickValue: 365,
        //   image: '/static/images/icons/submission_icon.svg',
        // },
        // {
        //   key: 13,
        //   type: 'Registration Tracker',
        //   title: 'Automated tool to control business',
        //   content: '<ul><li>Save time and avoid headaches with automated tracking</li>'
        //   + '<li>Focus on your business rather than tracking changes to regulatory markets</li><li>Get “big picture” data insights in one simple graphic</li><li>Instantly share information with teammates</li></ul>',
        //   url: '/layout/trackplusdashboard',
        //   clickValue: 410,
        //   image: '/static/images/icons/track_plus_icon.svg',
        // },
        // {
        //   key: 14,
        //   type: 'Regulatory Watch',
        //   title: 'Instant access to global RA experts',
        //   content: '<ul><li>Get the latest updates on regulations and guidance</li>'
        //   + '<li>Customize your feed to the markets that affect your business</li><li>Choose from global updates or narrow your newsfeed to key markets</li><li>Flag important updates, archive items, and take control of regulatory updates</li></ul>',
        //   url: '/layout/regulatory-updates',
        //   clickValue: 450,
        //   image: '/static/images/icons/reg_alerts_icon.svg',
        // },
        // {
        //   key: 15,
        //   type: 'Regulatory Intelligence',
        //   title: 'Chart a course for regulatory approval',
        //   content: '<ul><li>Download at-a-glance market planning tools</li>'
        //   + '<li>Immediate answers to market access questions</li><li>Get targeted insights on key markets</li><li>Simplifies complex requirements</li></ul>',
        //   url: '/layout/regulatoryprocesscharts',
        //   clickValue: 500,
        //   image: '/static/images/icons/reg_intel_icon.svg',
        // },
        // {
        //   key: 16,
        //   type: 'Training & Compliance',
        //   title: 'Ensure compliance with UL ComplianceWire<sup style="font-size: 20px">®</sup>',
        //   content: '<ul><li>Best-in-class validated Part 11 LMS</li>'
        //   + '<li>Learning solution used by the US FDA</li><li>Automate the administration of regulatory compliance</li></ul>',
        //   url: '/layout/market-place/service/8',
        //   clickValue: 545,
        //   image: '/static/images/icons/cw.svg',
        // },
        // {
        //   key: 17,
        //   type: 'Quality Management System (eQMS)',
        //   title: 'eQMS built for medical device industry',
        //   content: '<ul><li>Integrated design controls, risk management, and quality process</li>'
        //   + '<li>Flexible review and approval workflows</li><li>Update your risk management file and avoid costly rework</li><li>Help your business remain audit-ready at all times</li></ul>',
        //   url: '/layout/market-place/service/5',
        //   clickValue: 605,
        //   image: '/static/images/icons/gg_icon.svg',
        // },
      ],
      // tourData: [...this.tourObject],
    };
  },
  methods: {
    openWelcomePopup() {
      this.tourIndex = -1;
      $('#modal_welcome').modal({
        backdrop: 'static',
        keyboard: false,
        show: true,
      });
      this.playNextTour();
    },
    playNextTour() {
      this.tourIndex += 1;
      if (this.tourIndex === this.tourObject.length) {
        $('#modal_dashboard').modal('hide');
        this.currentTour = {};
        // EventBus.$emit('openDrpDwnAccount');
        // $('#modal_accounts').modal({
        //   backdrop: 'static',
        //   keyboard: false,
        // });
        $('#modal_accounts').modal('hide');
        EventBus.$emit('closeDrpDwnAccount');
        $('#modal_endtour').modal({
          backdrop: 'static',
          keyboard: false,
        });
      } else {
        this.currentTour = { ...this.tourObject[this.tourIndex] };
        if (this.$i18n.locale === 'Portuguese') {
          const currentObject = this.currentTour;
          this.currentTour = this.textTranslation(currentObject);
        }
        EventBus.$emit('highlightNav', this.currentTour.url);
      }
    },
    previousTour() {
      this.tourIndex -= 1;
      if (this.tourIndex === -1) {
        $('#modal_dashboard').modal('hide');
        this.currentTour = {};
        EventBus.$emit('closeMobileSideBar');
        this.openWelcomePopup();
      }
      if (this.tourIndex === this.tourObject.length - 1) {
        $('#modal_dashboard').modal({
          backdrop: 'static',
          keyboard: false,
        });
        $('#modal_accounts').modal('hide');
        EventBus.$emit('closeDrpDwnAccount');
      } else {
        this.currentTour = { ...this.tourObject[this.tourIndex] };
        const currentObject = this.currentTour;
        if (this.$i18n.locale === 'Portuguese') {
          this.currentTour = this.textTranslation(currentObject);
        }
        EventBus.$emit('highlightNav', this.currentTour.url);
      }
    },
    textTranslation(currentTour) {
      if (currentTour.type === 'Dashboard') {
        currentTour.type = 'Painel';
        currentTour.title = 'Hub central para acessar<br/>principais recursos';
        currentTour.content = '<ul class="item-container"><li><span>Vá para uma seção específica no Painel para saber mais detalhes sobre nossos recursos e serviços.<span/></li>'
          + '<li><span>Visualize ou adicione registros e detalhes de conformidade no Rastreador de conformidade para seus produtos.<span></li><li><span>Acesse imediatamente os principais recursos, como ferramentas populares e documentos na seção Recursos.<span></li></ul>';
      } else if (currentTour.type === 'Marketplace') {
        currentTour.type = 'Marketplace';
        currentTour.title = 'Comprar recursos premium<br/>e assinaturas';
        currentTour.content = '<ul><li><span>Compre recursos e serviços premium no<br/>marketplace.<span></li>'
          + '<li><span>Opções de assinatura flexíveis para maximizar<br/>recursos para seus produtos.<span></li><li><span>Compre ferramentas e documentos premium.<span></li></ ul>';
      } else if (currentTour.type === 'Notifications') {
        currentTour.type = 'Notificações';
        currentTour.title = 'Ver mensagens sobre suas<br/>atividades recentes';
        currentTour.content = '<ul><li><span>Receba confirmação de compras, documentos e recursos de conformidade e muito mais.<span/></li><li><span>Receba confirmação quando uma certificação for aprovada para produtos.<span/></li><li><span>Receber mensagens sobre novos conteúdos.<span/></li></ul>';
      } else if (currentTour.type === 'Compliance Tracker') {
        currentTour.type = 'Rastreador de Conformidade';
        currentTour.title = 'Ferramenta automatizada <br/> para  controlar  autocertificações de produtos';
        const title1 = '<ul><li><span>Economize tempo com rastreamento de conformidade automatizado.<span/></li><li><span>Amplie seus negócios com atualizações avançadas de rastreamento de conformidade de suas certificações de produto.<span/></li >';
        const title2 = '<li><span>Obtenha insights de dados do “quadro geral” em um gráfico simples. Compartilhe instantaneamente recursos e informações com colegas de equipe.<span/></li></ul>';
        currentTour.content = `${title1}${title2}`;
      } else if (currentTour.type === 'Resources') {
        currentTour.type = 'Recursos';
        currentTour.title = 'Explore a conformidade do seu produto<br/>e os recursos de certificação';
        currentTour.content = '<ul><li><span>Quer explorar os recursos de certificação?<br/>Localize rapidamente os principais recursos e serviços.<span/></li><li><span>Acesso imediato aos detalhes do provedor de serviços.<span/></li><li><span>Estime custos e dados históricos para seu<br/>produto com padrões de auto certificação.<span/></li></ul>';
      }
      return currentTour;
    },
  },
  async mounted() {
    this.roleId = JSON.parse(localStorage.getItem('roleId'));
    const response = await getRamsTour();
    this.displayTour = sessionStorage.getItem('displayTour');
    sessionStorage.removeItem('displayTour');
    EventBus.$on('displayTour', () => {
      this.openWelcomePopup();
    });
    if ((response && response.new_user) || this.displayTour) this.openWelcomePopup();
    if (!this.displayRep) {
      this.tourObject = this.tourObject.filter((i) => i.type !== 'Representation Resources');
      for (let i = 0; i < this.tourObject.length; i += 1) {
        const obj = this.tourObject[i];
        if (obj.type === 'Tools') {
          obj.clickValue = '300';
        }
        if (obj.type === 'Market Insights') {
          obj.clickValue = '265';
        }
      }
    }
    if (this.roleId === 6) {
      this.tourObject = this.tourObject.filter((i) => i.type !== 'Smart Builder');
    }
    if (this.roleId === 3 || this.roleId === 6) {
      this.tourObject = this.tourObject.filter((i) => i.type !== 'Smart Docs');
    }
    if (!this.showSElink) {
      this.tourObject = this.tourObject.filter((i) => i.type !== 'Smart Exchange');
    }
    EventBus.$on('openRender', () => {
      this.tourIndex = this.tourObject.length - 1;
      this.currentTour = this.tourObject[this.tourIndex];
      $('#modal_dashboard').modal({
        backdrop: 'static',
        keyboard: false,
      });
      $('#modal_accounts').modal('hide');
      EventBus.$emit('closeDrpDwnAccount');
    });
  },
};
</script>

<style scoped>

</style>
